import { OperationPermissionEntityType, OperationPermissionEnum, OperationPermissionSubjectType } from "./operation-permission";

export interface FlattenedOperationPermission {
  entityUUID?: string; //id dell'entità per cui si crea l'operatonPermission (es. id dell'asset)
  entityType: OperationPermissionEntityType;
  subjectUUID: string;
  subjectType: OperationPermissionSubjectType;
  permission: OperationPermissionEnum;
}
